const CODE_LOGIN_CONTEXT_KEY = "tmrx_code_login_context";

export const saveCodeLoginContext = (context) => {
  if (!context) {
    return;
  }
  sessionStorage.setItem(CODE_LOGIN_CONTEXT_KEY, JSON.stringify(context));
};

export const getCodeLoginContext = () => {
  try {
    const raw = sessionStorage.getItem(CODE_LOGIN_CONTEXT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearCodeLoginContext = () => {
  sessionStorage.removeItem(CODE_LOGIN_CONTEXT_KEY);
};

export const buildCodeLoginContextFromUser = (user, code) => ({
  code: code || user?.code || "",
  notificationTypeId: user?.notificationTypeId,
  recordId: user?.recordId,
  transferRequestId: user?.transferRequestId,
  notificationId: user?.notificationId,
});
